import { Injectable } from '@angular/core';
import { RequestService } from '@core/services/request/request.service';
import { NotificationApi, NotificationPaths } from '../../model/notifications/notification-api.model';
import { RequestResponse } from '@core/services/request/model/request.model';
import { ApiDirectory } from '../../api-directory';
import { NotificationCountersApi } from '../../model/notifications/notification-counters-api.model';
import { Observable } from 'rxjs';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({
  providedIn: 'root',
})
export class ApiNotificationsService {
  constructor(private readonly _requestService: RequestService) {}

  fetch$(path: NotificationPaths): Observable<RequestResponse<NotificationApi[]>> {
    return this._requestService.get<RequestResponse<NotificationApi[]>>(ApiDirectory.Notificaciones.Listado({ path }), {
      hideErrorAlert: true,
      loading: LoadingIds.NOTIFICATIONS_PANEL,
    });
  }

  fetchCounters$(): Observable<RequestResponse<NotificationCountersApi>> {
    return this._requestService.get<RequestResponse<NotificationCountersApi>>(ApiDirectory.Notificaciones.Resumen({}), {
      loading: LoadingIds.NOTIFICATIONS_PANEL,
    });
  }

  markAllAsRead$(): Observable<RequestResponse<boolean>> {
    return this._requestService.post(
      ApiDirectory.Notificaciones.MarcarTodasComoLeidas({}),
      {},
      {
        loading: LoadingIds.NOTIFICATIONS_PANEL,
      }
    );
  }

  markOneAsRead$(notificationId: number): Observable<RequestResponse<boolean>> {
    return this._requestService.post(
      ApiDirectory.Notificaciones.MarcarUnaComoLeida({ notificationId }),
      {},
      {
        loading: LoadingIds.NOTIFICATIONS_PANEL,
      }
    );
  }

  archive$(notificationId: number): Observable<RequestResponse<boolean>> {
    return this._requestService.post(
      ApiDirectory.Notificaciones.Archivar({ notificationId }),
      {},
      {
        loading: LoadingIds.NOTIFICATIONS_PANEL,
      }
    );
  }

  unarchive$(notificationId: number): Observable<RequestResponse<boolean>> {
    return this._requestService.post(
      ApiDirectory.Notificaciones.Desarchivar({ notificationId }),
      {},
      {
        loading: LoadingIds.NOTIFICATIONS_PANEL,
      }
    );
  }
  archiveAll$(): Observable<RequestResponse<boolean>> {
    return this._requestService.post(
      ApiDirectory.Notificaciones.ArchivarTodas({}),
      {},
      {
        loading: LoadingIds.NOTIFICATIONS_PANEL,
      }
    );
  }
}
